module.exports = __webpack_public_path__ + "img/CK.8923c210.png";